module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.error
    }
  }, [(_vm.label) ? _c('label', {
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": _vm.name,
      "required": _vm.required
    },
    on: {
      "change": function($event) {
        return _vm.updateValue($event.target.value)
      }
    }
  }, [(_vm.placeholder) ? _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.placeholder))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.identifiers), function(identifier) {
    return _c('option', {
      domProps: {
        "value": identifier.identifier,
        "selected": _vm.value == identifier.identifier
      }
    }, [_vm._v("\n      " + _vm._s(identifier.identifier) + "\n      "), _vm._l((identifier.attributes), function(attr, key) {
      return [_vm._v(_vm._s(key > 0 ? ',' : ' => ') + " " + _vm._s(attr.name) + ": "), _c('strong', [_vm._v(_vm._s(attr.value))])]
    })], 2)
  })], 2), _vm._v(" "), (_vm.error) ? _c('span', {
    staticClass: "help-block",
    domProps: {
      "innerHTML": _vm._s(_vm.error)
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c04aa5fa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/inputs/InputIdentifiers.vue
// module id = 1037
// module chunks = 34